import { Report } from '../common/models/Reports/Report';
import { Delete, Get, Post, Put } from '../util/HttpUtils';
import { ErrorHandler, RequestOptions } from '../common/models/GenericTypes';
import {
  AddDashboardRequest,
  Dashboard,
  ShareDashboardRequest,
  UpdateDashboardRequest,
  UpdateElementsDashboardRequest,
} from 'common/models/Dashboard/Dashboard';
import {
  CreateDashboardKioskLinkRequest,
  DashboardKioskLink,
  UpdateDashboardKioskLinkRequest,
} from 'common/models/Dashboard/DashboardKioskLink';
import { TaggingReportFilter } from 'common/models/Reporting/AnalyticsFilterData';
import { TaggingReportRecord } from 'common/models/Reports/TaggingReportRecord';

export async function GetActivityReports(errorHandler?: ErrorHandler) {
  const options: RequestOptions = {
    errorHandler,
  };

  return Get<Report[]>('api/activity/reports', options);
}

export async function GetDashboardReports(errorHandler?: ErrorHandler) {
  const options: RequestOptions = {
    errorHandler,
  };

  return Get<Report[]>('api/misc/reports', options);
}

export async function AddNewDashboard(req: AddDashboardRequest, errorHandler?: ErrorHandler) {
  const options: RequestOptions = {
    errorHandler,
  };

  return Post<number>('api/dashboards', options, req);
}

export async function GetDashboards(errorHandler?: ErrorHandler) {
  const options: RequestOptions = {
    errorHandler,
  };

  return Get<Dashboard[]>('api/dashboards', options);
}

export async function GetAllDashboards(errorHandler?: ErrorHandler) {
  const options: RequestOptions = {
    errorHandler,
  };

  return Get<Dashboard[]>('api/dashboards/all', options);
}

export async function GetDashboardById(dashboardId: number, errorHandler?: ErrorHandler) {
  const options: RequestOptions = {
    errorHandler,
  };

  return Get<Dashboard>(`api/dashboards/${dashboardId}`, options);
}

export async function UpdateDashboard(req: UpdateDashboardRequest, errorHandler?: ErrorHandler) {
  const options: RequestOptions = {
    noDataReturned: true,
    errorHandler,
  };

  return Put<number>(`api/dashboards/${req.id}`, options, req);
}

export async function DeleteDashboard(dashboardId: number, errorHandler?: ErrorHandler) {
  const options: RequestOptions = {
    noDataReturned: true,
    errorHandler,
  };

  return Delete<number>(`api/dashboards/${dashboardId}`, options);
}

export async function ShareDashboard(req: ShareDashboardRequest, errorHandler?: ErrorHandler) {
  const options: RequestOptions = {
    noDataReturned: true,
    errorHandler,
  };

  return Post<number>('api/dashboards/share', options, req);
}

export async function UpdateElements(
  req: UpdateElementsDashboardRequest,
  errorHandler?: ErrorHandler
) {
  const options: RequestOptions = {
    noDataReturned: true,
    errorHandler,
  };

  return Put<number>(`api/dashboards/${req.id}/elements`, options, req);
}

export async function GetAllDashboardKioskLinks(
  showDeleted: boolean = false,
  errorHandler?: ErrorHandler
) {
  const options: RequestOptions = {
    errorHandler,
  };

  return Get<DashboardKioskLink[]>(
    `api/dashboards/all/kiosk-links?showDeleted=${showDeleted}`,
    options
  );
}

export async function UpdateDashboardKioskLink(
  req: UpdateDashboardKioskLinkRequest,
  errorHandler?: ErrorHandler
) {
  const options: RequestOptions = {
    noDataReturned: true,
    errorHandler,
  };

  return Put<number>('api/dashboards/kiosk-link', options, req);
}

export async function DeleteDashboardKioskLink(id: number, errorHandler?: ErrorHandler) {
  const options: RequestOptions = {
    noDataReturned: true,
    errorHandler,
  };

  return Delete<number>(`api/dashboards/kiosk-link/${id}`, options);
}

export async function CreateDashboardKioskLink(
  req: CreateDashboardKioskLinkRequest,
  errorHandler?: ErrorHandler
) {
  const options: RequestOptions = {
    errorHandler,
  };

  return Post<string>('api/dashboards/kiosk-link', options, req);
}

export async function GetKioskDashboard(token: string, errorHandler?: ErrorHandler) {
  const options: RequestOptions = {
    errorHandler,
  };

  return Get<Dashboard>(`api/DashboardKiosks/${token}`, options);
}

export async function GetTaggingReportSummaryData(
  filter: TaggingReportFilter,
  errorHandler?: ErrorHandler
) {
  const options: RequestOptions = {
    errorHandler,
  };

  return Post<TaggingReportRecord[]>('api/activity/reports/tagging', options, filter);
}

export async function GetTaggingReportModuleData<T>(
  entityId: number,
  filter: TaggingReportFilter,
  errorHandler?: ErrorHandler
) {
  const options: RequestOptions = {
    errorHandler,
  };

  return Post<T[]>(`api/activity/reports/tagging?entityId=${entityId}`, options, filter);
}
